import { Component, Input } from '@angular/core';

@Component({
  selector: 'monorepo-tag-display',
  templateUrl: './tag-display.component.html',
  styleUrls: ['./tag-display.component.scss'],
})
export class TagDisplayComponent {
  @Input() tags: (string | number)[] = [];
  @Input() title = 'All tags';
}
